// extracted by mini-css-extract-plugin
export default {"messageList":"styles_messageList__1yFUU","messageTurn":"styles_messageTurn__Ec+v6"};